import { h } from 'preact';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import ChevronRight from '../../molecules/Icon/ChevronRight';

const SubMenu = ({ className, menuItem, subMenus, style, isActive, isDesktop, onToggleState }) => {
  const { title, subMenuClassName = '' } = menuItem;

  const [expanded, setExpanded] = useState(false);

  const buttonRef = useRef();
  const onToggleRef = useRef(onToggleState);

  onToggleRef.current = onToggleState;

  const handleExpandedView = useCallback(() => {
    if (!isDesktop) {
      setExpanded(prevState => !prevState);
      return;
    }
    if (!expanded) {
      setExpanded(true);
      if (typeof onToggleRef.current === 'function') {
        onToggleRef.current(true, buttonRef.current);
      }
    }
  }, [isDesktop, expanded]);

  useEffect(() => {
    if (!isDesktop) {
      return;
    }

    setExpanded(isActive);
  }, [isActive, isDesktop]);

  return (
    <li
      className={`sub-menu-container ${subMenuClassName}`}
      style={!isDesktop ? { width: '100%' } : {}}
      itemType="http://www.schema.org/SiteNavigationElement"
      itemScope
    >
      <div
        ref={buttonRef}
        className={`${className} sub-menu-link${expanded ? ' active' : ''}`}
        style={style}
        onClick={handleExpandedView}
        onMouseEnter={() => {
          if (isDesktop) {
            handleExpandedView();
          }
        }}
        itemProp="name"
      >
        <span className="title ellipsis">{title}</span>
        <span
          className={`arrow-icon${expanded ? ' expanded' : ''}${isDesktop ? ' desktop-icon' : ''}${
            isActive ? ' active-menu-icon' : ''
          }`}
        >
          <ChevronRight color={style.color} />
        </span>
      </div>
      {expanded && subMenus()}
    </li>
  );
};

export default SubMenu;
